var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size=32px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.829 6.8183L1.5835 12.4834L15.9064 17.5384C16.3686 17.7014 16.8727 17.7014 17.335 17.5384L30.3087 12.9604C30.4118 12.9239 30.5012 12.8569 30.5652 12.7683C30.6291 12.6796 30.6645 12.5736 30.6666 12.4643C30.6687 12.3551 30.6374 12.2478 30.5769 12.1567C30.5164 12.0657 30.4296 11.9953 30.3281 11.9549L17.4145 6.8183C16.9053 6.61615 16.3382 6.61615 15.829 6.8183Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.5835 12.4833V20.3526",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.02885 14.767V21.5342C8.02661 21.8576 8.12199 22.1741 8.30252 22.4424C8.48304 22.7107 8.74032 22.9183 9.04071 23.038L16.0228 25.616C16.4066 25.7707 16.8355 25.7707 17.2194 25.616L24.2014 23.038C24.502 22.9184 24.7596 22.7109 24.9405 22.4426C25.1214 22.1743 25.2172 21.8577 25.2154 21.5342V14.767",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/educationIcon.d25ceabf4169e64db3497698ada1f90c.svg";
export { ForwardRef as ReactComponent };